// French for the new-engagement modal. Registered on load.
import { registerFr } from '../i18n/index.js';

registerFr({
  'Client and name are required': 'Le client et le nom sont requis',
  'Engagement {code} created': 'Mandat {code} créé',
  'New engagement': 'Nouveau mandat',
  'Client': 'Client',
  'select a client…': 'sélectionner un client…',
  'Name': 'Nom',
  'Warehouse slotting optimisation': 'Optimisation de l’emplacement en entrepôt',
  'Code — uppercase alnum, unique, immutable': 'Code — majuscules et chiffres, unique, immuable',
  'leave blank to derive from the client': 'laisser vide pour le dériver du client',
  'Sponsor': 'Sponsor',
  'pick a client first': 'choisir d’abord un client',
  'not named yet': 'pas encore nommé',
  'no contacts on this client': 'aucun contact chez ce client',
  'Who signs. Naming them here clears the counterpart condition on gate {gate}.': 'Qui signe. Le désigner ici satisfait la condition correspondante sur le gate {gate}.',
  'Estimate ({currency})': 'Estimation ({currency})',
  'Ballpark, before milestones exist.': 'Ordre de grandeur, avant que les jalons n’existent.',
  'Commercial model': 'Modèle commercial',
  'Fixed price': 'Forfait',
  'Time & materials': 'En régie',
  'Capped T&M': 'Régie plafonnée',
  'Retainer': 'Retainer',
  'Currency': 'Devise',
  'Review window (d)': 'Délai de vérification (j)',
  'Correspondence language': 'Langue de correspondance',
  'inherit from the client — {language}': 'hériter du client — {language}',
  'inherit from the client': 'hériter du client',
  'Everything produced inside the engagement — proposals, descriptors, questions — is written in it.': 'Tout ce qui est produit dans le mandat — propositions, descriptifs, questions — y est rédigé.',
  'Parent engagement (optional)': 'Mandat parent (facultatif)',
  'none': 'aucun',
  'Kickoff date (optional)': 'Date de kickoff (facultatif)',
  'The engagement opens in {phase} behind gate {gate}. Its code is used in refs and the agent workspace directory and cannot be changed later.': 'Le mandat s’ouvre en {phase} derrière le gate {gate}. Son code est utilisé dans les refs et le répertoire de travail de l’agent, et ne peut plus être modifié ensuite.',
  'Qualify': 'Qualification',
  'Cancel': 'Annuler',
  'Creating…': 'Création…',
  'Create engagement': 'Créer le mandat',
}, 'NewEngagementModal');
